import { CandidateFilterType } from '@pflegia/types/api/candidate/candidate-filter-type';
import { CandidatePriority } from '@pflegia/types/api/candidate/candidate-priority';
import { EmploymentType, PermanentOrTemporaryJob } from '@pflegia/types/api/candidate/employment-type';
import { TypeOfWork } from '@pflegia/types/api/candidate/type-of-work';
import { FilterValue } from '@pflegia/types/api/job-board/filter-value';
import { isDefined } from '@pflegia/util/common/type-guards';

export const filterValuesToGuestFilters = (filterValues: FilterValue[], referencePriority?: CandidatePriority) => {
  let jobTitleIds: string[] = [];
  if (referencePriority) {
    jobTitleIds = filterValues
      .filter(({ type, positionDetails }) => {
        if (type !== CandidateFilterType.Position || !positionDetails) return false;
        return positionDetails.selected || !positionDetails.isPending || positionDetails.trackingPriority >= referencePriority;
      })
      .map(({ value }) => value);
  } else {
    jobTitleIds = filterValues.filter(({ type }) => type === CandidateFilterType.Position).map(({ value }) => value);
  }

  return {
    typesOfWork: filterValues.filter(({ type }) => type === CandidateFilterType.Facility).map(({ value }) => value as TypeOfWork),
    permanentOrTemporary: filterValues
      .filter(({ type }) => type === CandidateFilterType.TypeOfJob)
      .map(({ value }) => value as PermanentOrTemporaryJob)[0],
    departmentIds: filterValues.filter(({ type }) => type === CandidateFilterType.Department).map(({ value }) => value),
    employmentTypes: filterValues.filter(({ type }) => type === CandidateFilterType.Employment).map(({ value }) => value as EmploymentType),
    jobTitleIds,
    locations: filterValues
      .map(({ locationObject, type }) => (type === CandidateFilterType.Location ? locationObject : null))
      .filter(isDefined),
    jobPositionTitleQueries: filterValues
      .filter(({ type }) => type === CandidateFilterType.JobPositionTitleQueries)
      .map(({ value }) => value),
  };
};
